let $a = document.querySelectorAll('a');

$a.forEach((value, index) => {
  let target = value.getAttribute('target');

  if(target === '_blank') {
    value.setAttribute('rel', 'noopener noreferrer');
  }
});
